<template>
	<div>
		<el-card>
			<el-form :model="form" ref="userform" :inline="true">
				<el-form-item label="用户姓名:">
					<el-input placeholder="请输入用户姓名" v-model="form.nickname" style="width: 350px;"></el-input>
				</el-form-item>
				<el-form-item label="用户手机:">
					<el-input placeholder="请输入用户手机" v-model="form.tel" style="width: 350px;"></el-input>
				</el-form-item>
				<el-form-item label="调整编号:">
					<el-input placeholder="请输入调整编号" v-model="form.orderid" style="width: 350px;"></el-input>
				</el-form-item>
				<el-form-item label="调整日期:">
					<el-date-picker v-model="form.time" type="daterange" range-separator="至" start-placeholder="开始日期"
						end-placeholder="结束日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitForm()">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button  @click="resetForm()">重置</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="warning" @click="submitaddForm()">新增调整</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<el-card>
			<el-table :data="tableData" style="width: 100%">
				<el-table-column type="index" width="50">
				</el-table-column>
				<el-table-column prop="log_order_num" label="调整编号" >
				</el-table-column>
				<el-table-column prop="log_user_name" label="调整用户" >
					<template slot-scope="scope">
						<el-button  @click="submituserinfo(scope.row)">{{scope.row.log_user_name}}</el-button>
					</template>
				</el-table-column>
				<el-table-column prop="log_user_phone" label="手机号" >
				</el-table-column>
				<el-table-column prop="log_money" label="调整金额" >
				</el-table-column>
				<el-table-column prop="log_time" label="提现处理时间">
				</el-table-column>
				<el-table-column prop="log_description" label="调整描述" width="180">
				</el-table-column>
				<el-table-column prop="option_admin" label="后台操作人" width="180">
				</el-table-column>
				
			</el-table>
			<Pageing :page="page" :size="size" :total="total" @current-change="handleChangePage"></Pageing>
		</el-card>
		
		<el-dialog title="用户历史交易列表" :visible.sync="dialogFormVisible">
			<div>
				用户姓名：<el-input v-model="userinfo.name" disabled style="width: 100px;"></el-input>
				用户账户：<el-input v-model="userinfo.id" disabled style="width: 100px;"></el-input>
			</div>
			<el-table :data="userinfolist" style="width: 100%">
				<el-table-column type="index" width="50">
				</el-table-column>
				<el-table-column prop="start_time" label="日期" >
				</el-table-column>
				<el-table-column prop="price" label="交易金额" >
				</el-table-column>
				<el-table-column prop="bbeforewithdrawal" label="交易前余额" >
				</el-table-column>
				<el-table-column prop="endwithdrawal" label="交易后余额" >
				</el-table-column>
				<el-table-column prop="log_time" label="交易状态">
					<template slot-scope="scope">
						<div >
							{{scope.row.state == '1'? "成功":scope.row.state == '0'?'进行中':'已拒绝'}}
						</div>
						<div ></div>
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="交易备注" width="180">
				</el-table-column>
			</el-table>
			<div style="height: 80px;">
				<Pageing :page="userinfopage" :size="userinfosize" :total="userinfototal" @current-change="handleChangeuserPage"></Pageing>
			</div>
			
		</el-dialog>
		<el-dialog title="添加资金调整" :visible.sync="dialogaddFormVisible" width="700px"  style="height: 862px;" @close="close">
		  <el-form :model="useraddinfo">
			<el-form-item label="用户账户" :label-width="formLabelWidth">
			  <el-input v-model="useraddinfo.user" placeholder="请输入用户账户"  autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="用户手机" :label-width="formLabelWidth">
			  <el-input v-model="useraddinfo.tel" placeholder="请输入用户手机" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="真实姓名" :label-width="formLabelWidth">
			  <el-input v-model="useraddinfo.enter_name" placeholder="请输入真实姓名" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="身份证号" :label-width="formLabelWidth">
			  <el-input v-model="useraddinfo.user_idcard" placeholder="请输入身份证号" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="调整金额" :label-width="formLabelWidth">
			  <el-input v-model="useraddinfo.money" placeholder="请输入调整金额" type='int' autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="调整理由" :label-width="formLabelWidth">
			  <el-input v-model="useraddinfo.remark" placeholder="请输入调整理由" autocomplete="off"></el-input>
			</el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="closedialogaddFormVisible()">取 消</el-button>
		    <el-button type="primary" @click="sumbmitadd()">确 定</el-button>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	import Cookie from 'js-cookie'
	import Pageing from '../../components/page/page.vue'
	import {
		getadjustlist,
		getadjustuserinfo,
		submitadd
	} from '../../api/recharge.js'
	export default {
		components: {
			Pageing
		},
		data() {
			return {
				formLabelWidth: '120px',
				dialogFormVisible:false,
				dialogaddFormVisible:false,
				page:1,
				size:10,
				total:0,
				tableData: [],
				runmoney:0,
				checkAll: false,
				form: {
					nickname:'',
					tel:'',
					type:'',
					orderid: '',
					time: '',
				},
				moneyform:{
					incomemoney:0,
					runwater:0,
					paymoney:0,
				},
				forminfo:{},
				userinfo:{
					name:'',
					id:''
				},
				useraddinfo:{
					user:'',
					money:'',
					remark:'',
					tel:'',
					enter_name:'',
					user_idcard:''
				},
				userinfolist:[],
				userinfoid:'',
				userinfopage:1,
				userinfosize:10,
				userinfototal:0,
			};
		},
		mounted() {
			this.getuserlist()
		},
		methods: {
			//用户点击详情
			submituserinfo(e){
				this.userinfoid = e.log_user
				this.getuserinfo()
				this.dialogFormVisible = true
			},
			getuserinfo(){
				getadjustuserinfo({
					uid:this.userinfoid,
					page:this.userinfopage
				}).then(res=>{
					this.userinfo.name = res.name
					this.userinfo.id = res.user
					this.userinfolist = res.list.data
					this.userinfototal = res.list.total
				})
			},
			//新增调整
			submitaddForm(){
				this.dialogaddFormVisible = true
			},
			sumbmitadd(){
				submitadd({
					data:this.useraddinfo,
					token:Cookie.get('token'),
				}).then(res=>{
					console.log(res);
					if(res.code==200){
						this.$message({
							message: res.msg,
							type: 'success'
						});
						this.closedialogaddFormVisible()
						this.getuserlist()
					}else{
						this.$message({
							message: res.msg,
							type: 'error'
						});
					}
					//this.resetuseradd()
				})
			},
			getuserlist(){
				getadjustlist({
					page:this.page,
					where:this.form
				}).then(res=>{
					//console.log(res);
					this.moneyform = res.moneyform
					this.tableData = res.list.data
					this.total = res.list.total 
					
				})
				
			},
			handinfo(e){
				console.log(e);
				this.dialogFormVisible = true
				this.forminfo = e
			},
			submitForm() {
				this.getuserlist()
			},
			handleChangePage(val){
				this.page = val
				this.getuserlist()
			},
			handleChangeuserPage(val){
				this.userinfopage = val
				this.getuserinfo()
			},
			resetForm(){
				this.$refs.userform.resetFields()
				this.form.nickname = ''
				this.form.tel = ''
				this.form.type = ''
				this.form.orderid = ''
				this.form.time = ''
				this.getuserlist()
			},
			closedialogaddFormVisible(){
				this.dialogaddFormVisible = false
				this.resetuseradd()
			},
			close(){
				this.resetuseradd()
			},
			resetuseradd(){
				this.useraddinfo.user = ''
				this.useraddinfo.money = ''
				this.useraddinfo.remark = ''
				this.useraddinfo.enter_name = ''
				this.useraddinfo.tel = ''
				this.useraddinfo.user_idcard = ''
			}
			
		}
	};
</script>

<style lang="less" scoped>
	.runmoney{
		display: flex; 
		flex-direction: column;
		align-items: center;
		ul{
			display: flex;
			li{
				text-align: center;
				margin: 0 20px;
			}
		}
	}
	
</style>
